import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Alert } from 'antd'

import classes from './VerifyContactsNotification.module.scss'

import ContactSettings from '../ContactSettings/ContactSettings'

const VerifyContactsNotification = (props) => {
    const dispatch = useDispatch()
    const hasNotConfirmedContact = useSelector(state => state.auth.hasNotConfirmedContact)

    useEffect(() => {
        if (!hasNotConfirmedContact) {
            props.history.push('/personal-account/profile')
        }
        else props.history.push('/personal-account/verify-contacts')
    }, [hasNotConfirmedContact, props.history, dispatch])

    return (
        <div className={classes.container}>
            <Alert
                className='mb-3'
                message="Внимание!"
                description="Для работы с личным кабинетом Вам необходимо подтвердить контактные данные"
                type="error"
                showIcon
            />
            <ContactSettings />
        </div>
    )
}

export default VerifyContactsNotification